import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { getSinglePipelineDetailThunk } from './pipeline';
import { isErrorWithMessage } from '../../helper';
import { resettingStageLoader } from '../slices/stage';
import { RootState } from '../store';
import StageApi from '../../apis/stage';
import { deleteStageParams, PipelineResponse, StageOrderParams, StageParams, updateStageParams } from '../../params/pipeline';

export const createStageThunk = createAsyncThunk(
    'stage/create',
    async ({ stage_name, pipeline_id, days_due, description }: StageParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const details = {
                stage_name, pipeline_id, days_due, description
            };
            const response = await StageApi.createStage(state.app.token, details);
            if (response?.success === 1) {
                await dispatch(getSinglePipelineDetailThunk(pipeline_id)).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingStageLoader());
        }
    }
);

export const updateStageOrderThunk = createAsyncThunk(
    'stage/updateorder',
    async (data: StageOrderParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response: PipelineResponse = await StageApi.updateStageOrder(state.app.token, data) as PipelineResponse;
            if (response?.success === 1) {
                return response.pipeline?.pipeline_stages;
            }
            return errorHandler(response?.msg as string || 'Updating stage order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingStageLoader());
        }
    }
);

export const deleteStageThunk = createAsyncThunk(
    'stage/delete',
    async (data: deleteStageParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await StageApi.deleteStage(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(getSinglePipelineDetailThunk(state.pipeline.selectedPipeline?.id as number)).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingStageLoader());
        }
    }
);

export const updateStageThunk = createAsyncThunk(
    'stage/update',
    async (data: updateStageParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await StageApi.updateStage(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(getSinglePipelineDetailThunk(state.pipeline.selectedPipeline?.id as number)).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Updating deal order failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingStageLoader());
        }
    }
);